import { createSelector } from "@reduxjs/toolkit";
import { IUserLoyaltyProgram } from "Bands/types";
import { API_ENDPOINTS } from "shared/constants";

import { IDataKeys } from "shared/types";
import { buildSingleItem } from "shared/utils";
import { buildData, dataSelector } from "../helpers";

export const userLoyaltyProgramsSelector = createSelector(
  dataSelector,
  data => buildData(data as any, IDataKeys.userLoyaltyProgram) as IUserLoyaltyProgram[]
);

const dataUserLoyaltyProgramsSelector = createSelector(
  dataSelector,
  data => data.userLoyaltyProgram
);

export const userLoyaltyProgramSelectorCreator = (id: string) =>
  createSelector(dataUserLoyaltyProgramsSelector, data => {
    const item = data?.[API_ENDPOINTS.USER_LOYALTY_PROGRAM(id)];
    return item ? buildSingleItem(item) : undefined;
  });
